import { render } from "./ThirdPage.vue?vue&type=template&id=77f228e6"
import script from "./ThirdPage.vue?vue&type=script&lang=js"
export * from "./ThirdPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__